function formatarMoeda(valor, moeda = "BRL") {
    if (typeof valor === "string") {
        valor = valor.replace(".", "").replace(",", ".");
    }
    return parseFloat(valor).toLocaleString("pt-br", {
        style: "currency",
        currency: moeda
    });
}
